import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, Navigate } from "react-router-dom";
import LoginGoogle from "./LoginGoogle";
import "./Login.css";
import { useLanguage } from "../LanguageContext";

function Login(props){
  const { t } = useLanguage();

    const [userData, setUserData] = useState({
        email: "",
        password: "",
    });
    // const [googleUser, setGoogleUser ] = useState([]);
    const [error, setError] = useState(null);
    const [userLoggedIn, setUserLoggedIn] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: "instant"
    })
    }, []);

    function handleChange(event){
        const newValue = event.target.value;
        const inputName = event.target.name;

        setUserData(prevValue =>{
            if (inputName === "email"){
                return {
                    email: newValue,
                    password: prevValue.password,
                };
            } else if (inputName === "password"){
                return {
                    email: prevValue.email,
                    password: newValue,
                };
            };
        });
    };

    function loginUser(email, pass){
      setLoading(true);
      axios({
        method: "POST",
        data: {
          email: email,
          password: pass,
          ip: props.addressIp
        },
        withCredentials: true,
        url: process.env.REACT_APP_SERVER_URL + process.env.REACT_APP_LOGIN_USER_URL,
      }).then((res) => {
        setLoading(false);
        loginResponse(res);
      }).catch((err) =>{
        setLoading(false);
        // A banned account is answered with 403 {banned, reason}, which axios treats as an error.
        if (err.response?.data?.banned) {
          loginResponse(err.response);
          return;
        }
        console.log(err);
      });

  //     fetch("http://localhost:4747/api/login", {
  //   method: "POST",
  //   body: {
      
  //   },
  //   headers: {
  //     "Content-Type": "application/json"
  //   },
  //   credentials: 'include'
  // })

    }

    function isValidEmail(email){
        return /\S+@\S+\.\S+/.test(email);
    }

    function isVallidPassword(pass){
        if (pass.length <= 0){
            setError(t("loginEnterPassword"));
            return false;
        }
        // else if (pass.length < 6)
        // {
        //     setError("Hasło musi zawierać minimum 6 znaków.");
        //     return false;
        // }
        else{
            return true;
        }
    }

    const handleSubmit = (event) =>{
      event.preventDefault();
        if (!isValidEmail(userData.email))
        {
            if (userData.email === undefined || userData.email === "" || userData.email.length <= 0){
                setError(t("loginEnterEmail"));
            }else {
                setError(t("loginInvalidEmail"));
            }
            return;
        }

        if (!isVallidPassword(userData.password))
        {
            return;
        }

        setError(null);

        // props.loginUser(userData.email, userData.password, handleLoginResponse);
        loginUser(userData.email, userData.password);
    }

    function loginResponse(response){

      if (response.data?.banned) {
        setError(t("loginBanned") + (response.data.reason || t("loginBannedNoReason")));
        return;
      }

      if (response.data === "0"){
        // return "Niepoprawny login lub hasło.";
        setError(t("loginInvalidCredentials"));
        return;
      }

      const status = response.status;
      // console.log(status);
      switch (status){
          case 881:
          return "Użytkownik o podanym emailu nie istnieje.";
          case 882:
          return "Podane hasło jest niepoprawne.";
          case 200:
              const { username, email, active, dataStatus, _id } = response.data;

              props.setUserData(response.data);
              props.setUserState("zalogowano pomyślnie");
              props.createCookie(response.data);

              // console.log(response.data);
              // redirect("/");
              // this.props.history.push("/");
              // redirect("/");
              // <Navigate to={"/"} replace={true} />
              setUserLoggedIn(true);

              break;
              default:
                  return "Unknown login error!";
      };
  };

    function handleLoginResponse(response){
        if (response === "+"){
            // setRegisterStatus(true);
            // toast("Logowanie poprawne")
        }
        else{
            setError(response);
        }
    };

    if (userLoggedIn){
      return <Navigate to={"/"} />
    } else {
    return(
      
        <main className="login-page">
          <header className="login-heading"><p>{t("loginKicker")}</p><h1>{t("login")}</h1><span>{t("loginIntro")}</span></header>
          <div className="login-layout">
            <section className="login-form-section"><h2>{t("loginFormTitle")}</h2>
          <form className="login-form" onSubmit={handleSubmit}>
            {/* <div className="form-group">
              <label htmlFor="email">email:</label>
              <input type="email" className="form-control" name="email" onChange={handleChange} value={userData.email}></input> */}
            <div className="login-field">
              <label htmlFor="floatingEmail">{t("contactEmail")}</label>
              <input type="email" className="form-control" id="floatingEmail" placeholder={t("emailPlaceholder")} name="email" onChange={handleChange} value={userData.email}></input>
            </div>
            {/* <div className="form-group">
              <label htmlFor="password">hasło:</label>
              <input type="password" className="form-control" name="password" onChange={handleChange} value={userData.password}></input> */}
            <div className="login-field">
              <label htmlFor="floatingPassword">{t("password")}</label>
              <input type="password" className="form-control" id="floatingPassword" placeholder={t("passwordPlaceholder")} name="password" onChange={handleChange} value={userData.password}></input>
            </div>
            {/* <div className="form-group">
              <label for="password2">powtórz hasło:</label>
              <input type="password" className="form-control" name="password2" onChange={handleChange} value={userData.password2}></input>
            </div>
            <div className="recaptcha">
            <ReCAPTCHA sitekey={key} onChange={handleRecaptcha} />
            </div> */}
            {loading ? <div className="loader"></div> :
            <button type="submit">{t("loginSubmit")}</button>
          }
          <div className="login-secondary-links">
            <Link to={"/resetHasla"}>{t("forgotPassword")}</Link>
            <span>{t("noAccount")} <Link to={"/rejestracja"}>{t("createAccount")}</Link></span>
          </div>
          </form>
          <p className="login-error">{error}</p>
            </section>
            <aside className="login-social-section"><h2>{t("loginGoogleTitle")}</h2><p>{t("loginGoogleIntro")}</p><div className="login-google"><LoginGoogle loginResponse={loginResponse} /></div></aside>
          </div>
        </main>
    );
  };

};

export default Login;